import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { IVendor, IVendorsDataTableProps } from '../Vendors.types';

const VendorsDataTable = (props: IVendorsDataTableProps): JSX.Element => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Vendor Id</th>
                    <th>Vendor Name</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.data && props.data.map((value: IVendor, index: number) => {
                    return (
                        <tr key={`row-${index}`}>
                            <td key={`vendor-id-${index}`}>{value.vendorId}</td>
                            <td key={`vendor-name-${index}`}>{value.vendorName}</td>
                            <td key={`vendor-editCol-${index}`}>
                                <Button
                                    variant='secondary'
                                    onClick={_ => props.onEdit(value.id)}
                                    >
                                    Edit
                                </Button>
                            </td>
                            <td key={`vendor-deleteCol-${index}`}>
                                <Button
                                    variant='danger'
                                    onClick={_ => props.onDelete(value.id)}
                                    >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default VendorsDataTable;
